import axios from "axios";
import { Toast } from "../../lib/helpers/helpers";
import API_MAP from "../../services/uri";

export const createShopItem = async (credentials) => {
	const response = await axios.post(`${API_MAP.createShopItem}`, credentials);
	console.log("Fetch shop items ===>\n", response);
	return response.data;
};

export const fetchShopItems = async ({ weddingID }) => {
	try {
		const response = await axios.get(
			`${API_MAP.getShopItems}?weddingId=${weddingID}`
		);

		const { hasError } = response.data;
		if (hasError) {
			console.log("Fetch shop items error ===>\n", response);
			const { message, title } = response.data.errors;
			Toast.fire({
				icon: "error",
				title: `${title}\n${message}`,
			});
			return;
		}
		// console.log(response.data.data.items);
		return response.data?.data?.items;
	} catch (error) {
		console.log("Checking shop item data exist===========>\n", error);
	}
};

export const editShopItem = async ({ credentials }) => {
	const response = await axios.put(`${API_MAP.editShopItem}`, credentials);
	return response.data;
};

export const deleteShopItem = async (credentials) => {
	console.log(credentials);
	try {
		const response = await axios.delete(
			`${API_MAP.deleteShopItem}?itemId=${credentials}`
		);

		console.log("delete shop item error ===>\n", response);
		const { hasError } = response.data;
		if (hasError) {
			const { message, title } = response.data.errors;
			Toast.fire({
				icon: "error",
				title: `${title}\n${message}`,
			});
			return;
		}
		Toast.fire({
			icon: "success",
			title: `${response.data.title}\n${response.data.message}`,
		});
		return response.data;
	} catch (error) {
		console.log("delete shop item error===========>\n", error);
	}
};

export const deleteShopImage = async (credentials) => {
	console.log(credentials);
	try {
		const response = await axios.delete(
			`${API_MAP.deleteShopImage}?id=${credentials}`
		);

		console.log("delete shop image res ===>\n", response);
		const { hasError } = response.data;
		if (hasError) {
			const { message, title } = response.data.errors;
			Toast.fire({
				icon: "error",
				title: `${title}\n${message}`,
			});
			return;
		}
		Toast.fire({
			icon: "success",
			title: `${response.data.title}\n${response.data.message}`,
		});
		return response.data.data;
	} catch (error) {
		console.log(
			"delete shop image error===========>\n",
			error,
			error?.response
		);
	}
};
